{
  "Default": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 9100,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 9100,
      "LVN": 6800,
      "Caregiver": 2800,
      "CNA": 4000,
      "CHHA": 4000
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2400,
      "CNA": 2900,
      "CHHA": 2900
    }
  },
  "Alabama": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Alaska": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Arizona": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Arkansas": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "California": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 9100,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 9100,
      "LVN": 6800,
      "Caregiver": 2800,
      "CNA": 4000,
      "CHHA": 4000
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2400,
      "CNA": 2900,
      "CHHA": 2900
    }
  },
  "Colorado": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 7000,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "Connecticut": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Delaware": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "District of Columbia": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 7000,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "Florida": {
    "perVisit": {
      "RN-SOC": 13000,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 7000,
      "RN-ROC": 9000,
      "RN-Recert": 7500,
      "RN-Discharge": 7500,
      "RN-Supervisory": 7000,
      "LVN": 6000,
      "Caregiver": 2200,
      "CNA": 3200,
      "CHHA": 3200
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Georgia": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 9100,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 9100,
      "LVN": 6700,
      "Caregiver": 2800,
      "CNA": 4000,
      "CHHA": 4000
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "Hawaii": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 7000,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "Idaho": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Illinois": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11100,
      "RN-Recert": 9300,
      "RN-Discharge": 9300,
      "RN-Supervisory": 8700,
      "LVN": 6500,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "Indiana": {
    "perVisit": {
      "RN-SOC": 14300,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8400,
      "RN-ROC": 10500,
      "RN-Recert": 8800,
      "RN-Discharge": 8800,
      "RN-Supervisory": 8400,
      "LVN": 6000,
      "Caregiver": 2700,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Iowa": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Kansas": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Kentucky": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Louisiana": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Maine": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Maryland": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Massachusetts": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 6400,
      "Caregiver": 2800,
      "CNA": 4000,
      "CHHA": 4000
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "Michigan": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 7000,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "Minnesota": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2100,
      "CNA": 2300,
      "CHHA": 2300
    }
  },
  "Mississippi": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Missouri": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Montana": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Nebraska": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Nevada": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "New Hampshire": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "New Jersey": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 7000,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "New Mexico": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "New York": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 7000,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "North Carolina": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 7000,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "North Dakota": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Ohio": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 7000,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "Oklahoma": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Oregon": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Pennsylvania": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 7000,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "Rhode Island": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "South Carolina": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "South Dakota": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Tennessee": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Texas": {
    "perVisit": {
      "RN-SOC": 13200,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 7800,
      "RN-ROC": 9700,
      "RN-Recert": 8200,
      "RN-Discharge": 8200,
      "RN-Supervisory": 7800,
      "LVN": 6000,
      "Caregiver": 3000,
      "CNA": 3700,
      "CHHA": 3700
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Utah": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Vermont": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 7000,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "Virginia": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 7000,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "Washington": {
    "perVisit": {
      "RN-SOC": 14500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8700,
      "RN-ROC": 11600,
      "RN-Recert": 9700,
      "RN-Discharge": 9700,
      "RN-Supervisory": 8700,
      "LVN": 7000,
      "Caregiver": 2800,
      "CNA": 3800,
      "CHHA": 3800
    },
    "perHour": {
      "RN": 6700,
      "LVN": 5700,
      "Caregiver": 2500,
      "CNA": 3000,
      "CHHA": 3000
    }
  },
  "West Virginia": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Wisconsin": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  },
  "Wyoming": {
    "perVisit": {
      "RN-SOC": 13500,
      "RN-SOC-And-Regular": 14500,
      "RN-Regular": 8100,
      "RN-ROC": 10800,
      "RN-Recert": 9000,
      "RN-Discharge": 9000,
      "RN-Supervisory": 8100,
      "LVN": 6500,
      "Caregiver": 3000,
      "CNA": 3500,
      "CHHA": 3500
    },
    "perHour": {
      "RN": 6200,
      "LVN": 5200,
      "Caregiver": 2300,
      "CNA": 2700,
      "CHHA": 2700
    }
  }
}
